import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import PegadaianSplashScreen from '../modules/mudik-bersama/mb-pegadaian/PegadaianSplashScreen'
import PegadaianPage from '../modules/mudik-bersama/mb-pegadaian/PegadaianPage'
import PegadaianCheckoutPage from '../modules/mudik-bersama/mb-pegadaian/PegadaianCheckoutPage'
import PegadaianSearchBooking from '../modules/mudik-bersama/mb-pegadaian/PegadaianSearchBooking'
import PegadaianDetailBooking from '../modules/mudik-bersama/mb-pegadaian/PegadaianDetailBooking'
import PegadaianTableRute from '../modules/mudik-bersama/mb-pegadaian/PegadaianTableRute'


const PrivateRoutes = () => {

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='admin/dashboard' element={<DashboardWrapper />} />
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      <Route path='mudik-bersama/pegadaian' element={<PegadaianSplashScreen />} />
      <Route path='/mudik-bersama/pegadaian/reservasi' element={<PegadaianPage />} />
      <Route path='/mudik-bersama/pegadaian/rute-list' element={<PegadaianTableRute />} />
      <Route path='/mudik-bersama/pegadaian/booking' element={<PegadaianCheckoutPage />} />
      <Route path='/mudik-bersama/pegadaian/check-booking' element={<PegadaianSearchBooking />} />
      <Route path='/mudik-bersama/pegadaian/detail-booking' element={<PegadaianDetailBooking />} />
      {/* <Route path='form/citilink/:driverEmpno' element={<RatingCitilink />} /> */}
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
